
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M3 3h14v14H3z"}}),_c('path',{attrs:{"fill":"#1351f9","fill-rule":"nonzero","d":"M5.783 6.372h1.091a.35.35 0 0 1 0 .7H4.692a.349.349 0 0 1-.256-.111.349.349 0 0 1-.108-.253V4.526a.35.35 0 1 1 .7 0v1.19a6.65 6.65 0 1 1-1.616 4.346h1a5.65 5.65 0 1 0 1.37-3.69z"}})])])
      }
    
      }
    